export default async function  getAdsetData (campaignId,adsetId,clientId) {
    const url = `https://adyogiadsapi.adyogi.com/client/${clientId}/campaigns/${campaignId}/adsets/${adsetId}?source=amazon`
    try {
        const response = await fetch(url);
        const result = await response.json();
        return result
    } catch (error) {
        return error
    }
}